module.exports = __webpack_public_path__ + "img/tesys.ce1d12dc.png";